import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useTabsStore } from '@/stores/tabs'

// 懒加载路由组件
const Home = () => import('@/views/Home.vue')
const Login = () => import('@/views/auth/Login.vue')
const Register = () => import('@/views/auth/Register.vue')
const Dashboard = () => import('@/views/Dashboard.vue')
const Customers = () => import('@/views/customers/CustomerList.vue')
const CustomerDetail = () => import('@/views/customers/CustomerDetail.vue')
const EmailAccounts = () => import('@/views/email/EmailAccountList.vue')
const EmailList = () => import('@/views/email/EmailList.vue')
const EmailCampaigns = () => import('@/views/campaigns/CampaignList.vue')
const EmailTemplates = () => import('@/views/templates/TemplateList.vue')
const Products = () => import('@/views/products/ProductList.vue')
const Profile = () => import('@/views/auth/Profile.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { 
      requiresAuth: false,
      title: 'BUBU.IM - 跨境电商邮件聚合管理系统'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { 
      requiresAuth: false,
      title: '登录 - BUBU.IM'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { 
      requiresAuth: false,
      title: '注册 - BUBU.IM'
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { 
      requiresAuth: true,
      title: '仪表板 - BUBU.IM'
    }
  },
  {
    path: '/customers',
    name: 'Customers',
    component: Customers,
    meta: { 
      requiresAuth: true,
      title: '客户管理 - BUBU.IM'
    }
  },
  {
    path: '/customers/:id',
    name: 'CustomerDetail',
    component: CustomerDetail,
    props: true,
    meta: { 
      requiresAuth: true,
      title: '客户详情 - BUBU.IM'
    }
  },
  {
    path: '/email-accounts',
    name: 'EmailAccounts',
    component: EmailAccounts,
    meta: { 
      requiresAuth: true,
      title: '邮件账户 - BUBU.IM'
    }
  },
  {
    path: '/emails',
    name: 'Emails',
    component: EmailList,
    meta: { 
      requiresAuth: true,
      title: '邮件管理 - BUBU.IM'
    }
  },
  {
    path: '/campaigns',
    name: 'Campaigns',
    component: EmailCampaigns,
    meta: { 
      requiresAuth: true,
      title: '邮件营销 - BUBU.IM'
    }
  },
  {
    path: '/templates',
    name: 'Templates',
    component: EmailTemplates,
    meta: { 
      requiresAuth: true,
      title: '邮件模板 - BUBU.IM'
    }
  },
  {
    path: '/products',
    name: 'Products',
    component: Products,
    meta: { 
      requiresAuth: true,
      title: '产品管理 - BUBU.IM'
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { 
      requiresAuth: true,
      title: '个人资料 - BUBU.IM'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      title: '页面未找到 - BUBU.IM'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 全局路由守卫
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  // 设置页面标题
  document.title = to.meta.title || 'BUBU.IM'
  
  // 检查路由是否需要认证
  if (to.meta.requiresAuth) {
    // 如果没有token，重定向到登录页
    if (!authStore.token) {
      next({
        name: 'Login',
        query: { redirect: to.fullPath }
      })
      return
    }
    
    // 如果有token但没有用户信息，尝试获取用户信息
    if (!authStore.user) {
      try {
        await authStore.initAuth()
      } catch (error) {
        console.error('认证初始化失败:', error)
        next({
          name: 'Login',
          query: { redirect: to.fullPath }
        })
        return
      }
    }
  }
  
  // 如果已登录用户访问公开页面，重定向到仪表板
  const publicPages = ['Home', 'Login', 'Register']
  if (publicPages.includes(to.name) && authStore.isAuthenticated) {
    next({ name: 'Dashboard' })
    return
  }
  
  next()
})

// 移除路由后置守卫，因为在iframe模式下不使用路由管理标签页
// router.afterEach((to, from) => {
//   const authStore = useAuthStore()
//   if (authStore.isAuthenticated && to.name !== 'Login') {
//     const tabsStore = useTabsStore()
//     tabsStore.addTab(to)
//   }
// })

export default router
